import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { ITrainer } from 'models/trainer';
import { IVendor } from 'models/vendor';
import { useTranslation } from 'react-i18next';
import { getUserData } from 'helpers';
import { UserRoleName } from 'types/auth';


interface Props {
  open: boolean;
  loading: boolean;
  Trainer: ITrainer;
  Vendors: IVendor[];
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const EditTrainer: React.FC<Props> = ({ open, loading, Vendors, Trainer, onClose, onSubmit, onChanges }) => {

  const { roleName } = getUserData()

  const vendorOptions = Vendors.map((vendor) => {
    return { value: vendor.id, label: vendor.name };
  });
  const { t } = useTranslation()

  let basicFields: IFormField[] = [
    {
      name: 'FirstName',
      label: t('T_first_name'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_first_name'),
      internalLabel: true,
      defaultValue: Trainer.firstName,
      required: true
    },
    {
      name: 'MiddleName',
      label: t('T_middle_name'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_middle_name'),
      internalLabel: true,
      defaultValue: Trainer.middleName
    },
    {
      name: 'LastName',
      label: t('T_last_name'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_last_name'),
      internalLabel: true,
      defaultValue: Trainer.lastName,

      required: true
    },
    {
      name: 'FirstNameAr',
      label: `${t('T_first_name')} ${t('T_in_arabic')}`,
      type: InputTypes.TEXT,
      placeholder: `${t('T_enter_first_name')} ${t('T_in_arabic')}`,
      internalLabel: true,
      defaultValue: Trainer.firstNameAr
    },
    {
      name: 'MiddleNameAr',
      label: `${t('T_middle_name')} ${t('T_in_arabic')}`,
      type: InputTypes.TEXT,
      placeholder: `${t('T_enter_middle_name')} ${t('T_in_arabic')}`,
      internalLabel: true,
      defaultValue: Trainer.middleNameAr
    },
    {
      name: 'LastNameAr',
      label: `${t('T_last_name')} ${t('T_in_arabic')}`,
      type: InputTypes.TEXT,
      placeholder: `${t('T_enter_last_name')} ${t('T_in_arabic')}`,
      internalLabel: true,
      defaultValue: Trainer.lastNameAr,
    },

    {
      name: 'Biography',
      label: t('T_biography'),
      type: InputTypes.TEXTAREA,
      placeholder: t('T_enter_biography'),
      internalLabel: true,
      defaultValue: Trainer.biography,
      rows: 4,
      required: true
    },
    {
      name: 'VendorId',
      label: t('T_vendors'),
      type: InputTypes.SELECT,
      hidden: roleName === UserRoleName.VENDOR_ADMIN,
      placeholder: t('T_select_vendor'),
      options: vendorOptions,
      internalLabel: true,
      defaultValue: vendorOptions.find((vendor) => vendor.value === Trainer.vendorId),
      required: true
    },
    {
      name: 'Email',
      label: t('T_email'),
      type: InputTypes.EMAIL,
      internalLabel: true,
      defaultValue: Trainer?.email,
      required: true
    },

  ];



  let basicFields2: IFormField[] = [
    {
      name: "CountryCode",
      label: t("T_country_code"),
      type: InputTypes.COUNTRY,
      internalLabel: true,
      defaultValue: Trainer?.countryCode,
      rows: 4,
      required: true,
    },
  ]

  let basicFields3: IFormField[] = [

    {
      name: "PhoneNumber",
      label: t("T_phone_number"),
      type: InputTypes.NUMBER,
      placeholder: t("T_enter_phone_number"),
      internalLabel: true,
      defaultValue: Trainer?.phoneNumber,
      rows: 4,
      required: true,
    },
  ]

  let basicFields4: IFormField[] = [

    {
      name: 'Logo',
      label: t('T_Logo'),
      type: InputTypes.FILE,
      internalLabel: true,
      defaultImageUrl: Trainer.logo,
    },
  ]

  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_trainer')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
        <div style={{ display: 'flex' }}>
          <div style={{ width: '25%' }}>
            <Form
              fields={basicFields2}
              onChange={onChanges}
            />
          </div>

          <div style={{ width: '75%' }}>
            <Form
              fields={basicFields3}
              onChange={onChanges}
            />
          </div>
        </div>
        <Form fields={basicFields4} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_save')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditTrainer;
